<template>
  <v-card class="mb-4">
    <v-toolbar tabs flat color="secondary" dark>
        <v-icon left>mdi-clipboard-text</v-icon>
        <v-toolbar-title>Order</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
            <slot />
        </v-toolbar-items>
    </v-toolbar>
    <v-tabs v-model="tabs" dark color="secondary" slider-color="accent">
        <v-tab key="1" ripple>Order Details</v-tab>
        <v-tab key="2" ripple>Customer Details</v-tab>
        <v-tab key="3" ripple>History</v-tab>
        <v-tabs-items v-model="tabs" class="white elevation-1">
        <v-tab-item key="1">
            <order-detail
                :order="order"
                v-on:orderUpdate="updateModel($event)"
            ></order-detail>
        </v-tab-item>
        <v-tab-item key="2">
            <v-card flat>
                <customer-detail
                    :order="order"
                    v-on:orderUpdate="updateModel($event)"
                ></customer-detail>
            </v-card>
        </v-tab-item>
        <v-tab-item key="4">
            <v-card flat>
                <order-history :orderId="order.id"></order-history>
            </v-card>
        </v-tab-item>
        </v-tabs-items>
    </v-tabs>
</v-card>
</template>

<script>
import OrderDetail from "@components/orders/OrderDetail.vue";
import OrderHistory from "@components/orders/OrderHistory.vue";
import CustomerDetail from "@components/orders/CustomerDetail.vue";

export default {
    props:{
        order: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        tabs:0
    }),
    components:{
        OrderDetail,
        OrderHistory,
        CustomerDetail
    }
}
</script>

<style>

</style>